{
  "title": "On/Off (UA)",
  "source": "Unearthed Arcana 7 - Modern Magic",
  "levelAndSchool": "Transmutation cantrip (technomagic)",
  "level": 0,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "This cantrip allows you to activate or deactivate any electronic device within range, as long as the device has a clearly defined on or off function that can be easily accessed from the outside of the device. Any device that requires a software-based shutdown sequence to activate or deactivate cannot be affected by On/Off."
  ],
  "spellLists": ["eldritch-knight", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
